import _toConsumableArray from "D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _get from "D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _inherits from "D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { __rest } from "tslib";
import { isArray } from 'vega-util';
import { COLUMN, FACET, ROW } from '../channel';
import { hasConditionalFieldOrDatumDef, isFieldOrDatumDef, isValueDef } from '../channeldef';
import { boxPlotNormalizer } from '../compositemark/boxplot';
import { errorBandNormalizer } from '../compositemark/errorband';
import { errorBarNormalizer } from '../compositemark/errorbar';
import { channelHasField } from '../encoding';
import * as log from '../log';
import { isFacetMapping } from '../spec/facet';
import { SpecMapper } from '../spec/map';
import { isLayerRepeatSpec } from '../spec/repeat';
import { isUnitSpec } from '../spec/unit';
import { isEmpty, keys, omit, varName } from '../util';
import { isSignalRef } from '../vega.schema';
import { PathOverlayNormalizer } from './pathoverlay';
import { RangeStepNormalizer } from './rangestep';
import { replaceRepeaterInEncoding, replaceRepeaterInFacet } from './repeater';
import { RuleForRangedLineNormalizer } from './ruleforrangedline';
export var CoreNormalizer = /*#__PURE__*/function (_SpecMapper) {
  function CoreNormalizer() {
    var _this;
    _classCallCheck(this, CoreNormalizer);
    _this = _callSuper(this, CoreNormalizer, arguments);
    _this.nonFacetUnitNormalizers = [boxPlotNormalizer, errorBarNormalizer, errorBandNormalizer, new PathOverlayNormalizer(), new RuleForRangedLineNormalizer(), new RangeStepNormalizer()];
    return _this;
  }
  _inherits(CoreNormalizer, _SpecMapper);
  return _createClass(CoreNormalizer, [{
    key: "map",
    value: function map(spec, params) {
      // Special handling for a faceted unit spec as it can return a facet spec, not just a layer or unit spec like a normal unit spec.
      if (isUnitSpec(spec)) {
        var hasRow = channelHasField(spec.encoding, ROW);
        var hasColumn = channelHasField(spec.encoding, COLUMN);
        var hasFacet = channelHasField(spec.encoding, FACET);
        if (hasRow || hasColumn || hasFacet) {
          return this.mapFacetedUnit(spec, params);
        }
      }
      return _superPropGet(CoreNormalizer, "map", this, 3)([spec, params]);
    }
    // This is for normalizing non-facet unit
  }, {
    key: "mapUnit",
    value: function mapUnit(spec, params) {
      var parentEncoding = params.parentEncoding,
        parentProjection = params.parentProjection;
      var encoding = replaceRepeaterInEncoding(spec.encoding, params.repeater);
      var specWithReplacedEncoding = Object.assign(Object.assign({}, spec), encoding ? {
        encoding: encoding
      } : {});
      if (parentEncoding || parentProjection) {
        return this.mapUnitWithParentEncodingOrProjection(specWithReplacedEncoding, params);
      }
      var normalizeLayerOrUnit = this.mapLayerOrUnit.bind(this);
      var _iterator = _createForOfIteratorHelper(this.nonFacetUnitNormalizers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var unitNormalizer = _step.value;
          if (unitNormalizer.hasMatchingType(specWithReplacedEncoding, params.config)) {
            return unitNormalizer.run(specWithReplacedEncoding, params, normalizeLayerOrUnit);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return specWithReplacedEncoding;
    }
  }, {
    key: "mapRepeat",
    value: function mapRepeat(spec, params) {
      if (isLayerRepeatSpec(spec)) {
        return this.mapLayerRepeat(spec, params);
      } else {
        return this.mapNonLayerRepeat(spec, params);
      }
    }
  }, {
    key: "mapLayerRepeat",
    value: function mapLayerRepeat(spec, params) {
      var _this2 = this;
      var repeat = spec.repeat,
        childSpec = spec.spec,
        rest = __rest(spec, ["repeat", "spec"]);
      var row = repeat.row,
        column = repeat.column,
        layer = repeat.layer;
      var _params$repeater = params.repeater,
        repeater = _params$repeater === void 0 ? {} : _params$repeater,
        _params$repeaterPrefi = params.repeaterPrefix,
        repeaterPrefix = _params$repeaterPrefi === void 0 ? '' : _params$repeaterPrefi;
      if (row || column) {
        return this.mapRepeat(Object.assign(Object.assign({}, spec), {
          repeat: Object.assign(Object.assign({}, row ? {
            row: row
          } : {}), column ? {
            column: column
          } : {}),
          spec: {
            repeat: {
              layer: layer
            },
            spec: childSpec
          }
        }), params);
      } else {
        return Object.assign(Object.assign({}, rest), {
          layer: layer.map(function (layerValue) {
            var childRepeater = Object.assign(Object.assign({}, repeater), {
              layer: layerValue
            });
            var childName = (childSpec.name || '') + repeaterPrefix + "child__layer_".concat(varName(layerValue));
            var child = _this2.mapLayerOrUnit(childSpec, Object.assign(Object.assign({}, params), {
              repeater: childRepeater,
              repeaterPrefix: childName
            }));
            child.name = childName;
            return child;
          })
        });
      }
    }
  }, {
    key: "mapNonLayerRepeat",
    value: function mapNonLayerRepeat(spec, params) {
      var _a;
      var _spec = spec,
        repeat = _spec.repeat,
        childSpec = _spec.spec,
        data = _spec.data,
        remainingProperties = __rest(spec, ["repeat", "spec", "data"]);
      if (!isArray(repeat) && spec.columns) {
        // is repeat with row/column
        spec = omit(spec, ['columns']);
        log.warn(log.message.columnsNotSupportByRowCol('repeat'));
      }
      var concat = [];
      var _params$repeater2 = params.repeater,
        repeater = _params$repeater2 === void 0 ? {} : _params$repeater2,
        _params$repeaterPrefi2 = params.repeaterPrefix,
        repeaterPrefix = _params$repeaterPrefi2 === void 0 ? '' : _params$repeaterPrefi2;
      var row = !isArray(repeat) && repeat.row || [repeater ? repeater.row : null];
      var column = !isArray(repeat) && repeat.column || [repeater ? repeater.column : null];
      var repeatValues = isArray(repeat) && repeat || [repeater ? repeater.repeat : null];
      // cross product
      var _iterator2 = _createForOfIteratorHelper(repeatValues),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var repeatValue = _step2.value;
          var _iterator3 = _createForOfIteratorHelper(row),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var rowValue = _step3.value;
              var _iterator4 = _createForOfIteratorHelper(column),
                _step4;
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  var columnValue = _step4.value;
                  var childRepeater = {
                    repeat: repeatValue,
                    row: rowValue,
                    column: columnValue,
                    layer: repeater.layer
                  };
                  var childName = (childSpec.name || '') + repeaterPrefix + 'child__' + (isArray(repeat) ? "".concat(varName(repeatValue)) : (repeat.row ? "row_".concat(varName(rowValue)) : '') + (repeat.column ? "column_".concat(varName(columnValue)) : ''));
                  var child = this.map(childSpec, Object.assign(Object.assign({}, params), {
                    repeater: childRepeater,
                    repeaterPrefix: childName
                  }));
                  child.name = childName;
                  // we move data up
                  concat.push(omit(child, ['data']));
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var columns = isArray(repeat) ? spec.columns : repeat.column ? repeat.column.length : 1;
      return Object.assign(Object.assign({
        data: (_a = childSpec.data) !== null && _a !== void 0 ? _a : data,
        align: 'all'
      }, remainingProperties), {
        columns: columns,
        concat: concat
      });
    }
  }, {
    key: "mapFacet",
    value: function mapFacet(spec, params) {
      var _spec2 = spec,
        facet = _spec2.facet;
      if (isFacetMapping(facet) && spec.columns) {
        // is facet with row/column
        spec = omit(spec, ['columns']);
        log.warn(log.message.columnsNotSupportByRowCol('facet'));
      }
      return _superPropGet(CoreNormalizer, "mapFacet", this, 3)([spec, params]);
    }
  }, {
    key: "mapUnitWithParentEncodingOrProjection",
    value: function mapUnitWithParentEncodingOrProjection(spec, params) {
      var encoding = spec.encoding,
        projection = spec.projection;
      var parentEncoding = params.parentEncoding,
        parentProjection = params.parentProjection,
        config = params.config;
      var mergedProjection = mergeProjection({
        parentProjection: parentProjection,
        projection: projection
      });
      var mergedEncoding = mergeEncoding({
        parentEncoding: parentEncoding,
        encoding: replaceRepeaterInEncoding(encoding, params.repeater)
      });
      return this.mapUnit(Object.assign(Object.assign(Object.assign({}, spec), mergedProjection ? {
        projection: mergedProjection
      } : {}), mergedEncoding ? {
        encoding: mergedEncoding
      } : {}), {
        config: config
      });
    }
  }, {
    key: "mapFacetedUnit",
    value: function mapFacetedUnit(spec, params) {
      // New encoding in the inside spec should not contain row / column
      // as row/column should be moved to facet
      var _a = spec.encoding,
        row = _a.row,
        column = _a.column,
        facet = _a.facet,
        encoding = __rest(_a, ["row", "column", "facet"]);
      // Mark and encoding should be moved into the inner spec
      var mark = spec.mark,
        width = spec.width,
        projection = spec.projection,
        height = spec.height,
        view = spec.view,
        selection = spec.selection,
        _ = spec.encoding,
        outerSpec = __rest(spec, ["mark", "width", "projection", "height", "view", "selection", "encoding"]);
      var _this$getFacetMapping = this.getFacetMappingAndLayout({
          row: row,
          column: column,
          facet: facet
        }, params),
        facetMapping = _this$getFacetMapping.facetMapping,
        layout = _this$getFacetMapping.layout;
      var newEncoding = replaceRepeaterInEncoding(encoding, params.repeater);
      return this.mapFacet(Object.assign(Object.assign(Object.assign({}, outerSpec), layout), {
        // row / column has higher precedence than facet
        facet: facetMapping,
        spec: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, width ? {
          width: width
        } : {}), height ? {
          height: height
        } : {}), view ? {
          view: view
        } : {}), projection ? {
          projection: projection
        } : {}), {
          mark: mark,
          encoding: newEncoding
        }), selection ? {
          selection: selection
        } : {})
      }), params);
    }
  }, {
    key: "getFacetMappingAndLayout",
    value: function getFacetMappingAndLayout(facets, params) {
      var _a;
      var row = facets.row,
        column = facets.column,
        facet = facets.facet;
      if (row || column) {
        if (facet) {
          log.warn(log.message.facetChannelDropped([].concat(_toConsumableArray(row ? [ROW] : []), _toConsumableArray(column ? [COLUMN] : []))));
        }
        var facetMapping = {};
        var layout = {};
        for (var _i = 0, _arr = [ROW, COLUMN]; _i < _arr.length; _i++) {
          var channel = _arr[_i];
          var def = facets[channel];
          if (def) {
            var align = def.align,
              center = def.center,
              spacing = def.spacing,
              columns = def.columns,
              defWithoutLayout = __rest(def, ["align", "center", "spacing", "columns"]);
            facetMapping[channel] = defWithoutLayout;
            for (var _i2 = 0, _arr2 = ['align', 'center', 'spacing']; _i2 < _arr2.length; _i2++) {
              var prop = _arr2[_i2];
              if (def[prop] !== undefined) {
                layout[prop] = (_a = layout[prop]) !== null && _a !== void 0 ? _a : {};
                layout[prop][channel] = def[prop];
              }
            }
          }
        }
        return {
          facetMapping: facetMapping,
          layout: layout
        };
      } else {
        var _align = facet.align,
          _center = facet.center,
          _spacing = facet.spacing,
          _columns = facet.columns,
          _facetMapping = __rest(facet, ["align", "center", "spacing", "columns"]);
        return {
          facetMapping: replaceRepeaterInFacet(_facetMapping, params.repeater),
          layout: Object.assign(Object.assign(Object.assign(Object.assign({}, _align ? {
            align: _align
          } : {}), _center ? {
            center: _center
          } : {}), _spacing ? {
            spacing: _spacing
          } : {}), _columns ? {
            columns: _columns
          } : {})
        };
      }
    }
  }, {
    key: "mapLayer",
    value: function mapLayer(spec, _a) {
      // Special handling for extended layer spec
      var parentEncoding = _a.parentEncoding,
        parentProjection = _a.parentProjection,
        otherParams = __rest(_a, ["parentEncoding", "parentProjection"]);
      var encoding = spec.encoding,
        projection = spec.projection,
        rest = __rest(spec, ["encoding", "projection"]);
      var params = Object.assign(Object.assign({}, otherParams), {
        parentEncoding: mergeEncoding({
          parentEncoding: parentEncoding,
          encoding: encoding,
          layer: true
        }),
        parentProjection: mergeProjection({
          parentProjection: parentProjection,
          projection: projection
        })
      });
      return _superPropGet(CoreNormalizer, "mapLayer", this, 3)([rest, params]);
    }
  }]);
}(SpecMapper);
function mergeEncoding(_ref) {
  var parentEncoding = _ref.parentEncoding,
    _ref$encoding = _ref.encoding,
    encoding = _ref$encoding === void 0 ? {} : _ref$encoding,
    layer = _ref.layer;
  var merged = {};
  if (parentEncoding) {
    var channels = new Set([].concat(_toConsumableArray(keys(parentEncoding)), _toConsumableArray(keys(encoding))));
    var _iterator5 = _createForOfIteratorHelper(channels),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var channel = _step5.value;
        var channelDef = encoding[channel];
        var parentChannelDef = parentEncoding[channel];
        if (isFieldOrDatumDef(channelDef)) {
          // Field/Datum Def can inherit properties from its parent
          // Note that parentChannelDef doesn't have to be a field/datum def if the channelDef is already one.
          var mergedChannelDef = Object.assign(Object.assign({}, parentChannelDef), channelDef);
          merged[channel] = mergedChannelDef;
        } else if (hasConditionalFieldOrDatumDef(channelDef)) {
          merged[channel] = Object.assign(Object.assign({}, channelDef), {
            condition: Object.assign(Object.assign({}, parentChannelDef), channelDef.condition)
          });
        } else if (channelDef || channelDef === null) {
          merged[channel] = channelDef;
        } else if (layer || isValueDef(parentChannelDef) || isSignalRef(parentChannelDef) || isFieldOrDatumDef(parentChannelDef) || isArray(parentChannelDef)) {
          merged[channel] = parentChannelDef;
        }
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  } else {
    merged = encoding;
  }
  return !merged || isEmpty(merged) ? undefined : merged;
}
function mergeProjection(opt) {
  var parentProjection = opt.parentProjection,
    projection = opt.projection;
  if (parentProjection && projection) {
    log.warn(log.message.projectionOverridden({
      parentProjection: parentProjection,
      projection: projection
    }));
  }
  return projection !== null && projection !== void 0 ? projection : parentProjection;
}